import React from 'react';
import {CustomSwitchField} from "../../../../../../../elements/customSwitchField/CustomSwitchField";
import {RootState} from "../../../../../../../../app/store";
import {useAppSelector} from "../../../../../../../../app/hooks";
import styles from "./WorkingHours.module.css"
import {LocalTime} from "../../../../../../../../api/generated";
import {WorkingHoursRequest} from "../../../LocationForm";

interface Props<W> {
    day: string
    fieldName: string
    withBorderLine?: boolean
    workingHoursSelector: (state: RootState) => W | undefined;
    updateWorkingHours: (update: WorkingHoursRequest & { fieldName: string }) => void;
}

export const WorkingHours = <
    W extends WorkingHoursRequest
>({
      day,
      fieldName,
      workingHoursSelector,
      withBorderLine = true,
      updateWorkingHours
  }: Props<W>) => {

    const workingHours = useAppSelector(workingHoursSelector)

    const formatTime = (time?: LocalTime): string => {
        if (time) {
            const {hour, minute} = time
            let formattedHour = hour?.toString() || "00"
            let formattedMinute = minute?.toString() || "00"

            if (formattedHour.length !== 2) {
                formattedHour = "0" + formattedHour
            }
            if (formattedMinute.length !== 2) {
                formattedMinute = "0" + formattedMinute
            }

            return formattedHour + ":" + formattedMinute
        }
        return "00:00"
    }

    const toLocalTime = (time: string): LocalTime => {
        const [hour, minute] = time.split(":")
        return {
            hour: Number(hour),
            minute: Number(minute)
        }
    }

    return <div className={styles.wrapper}>
        <div className={styles.workingHoursRow}>
            <div className={styles.dayLabel}>{day}</div>
            <div className={styles.inputGroup}>
                <label>Open:</label>
                <input
                    type="time"
                    value={formatTime(workingHours?.openTime)}
                    onChange={(e) => updateWorkingHours({
                        openTime: toLocalTime(e.target.value),
                        closeTime: workingHours?.closeTime,
                        isClosed: !!workingHours?.isClosed,
                        fieldName
                    })}
                    disabled={workingHours?.isClosed}
                />
            </div>
            <div className={styles.inputGroup}>
                <label>Close:</label>
                <input
                    type="time"
                    value={formatTime(workingHours?.closeTime)}
                    onChange={(e) => updateWorkingHours({
                        openTime: workingHours?.openTime,
                        closeTime: toLocalTime(e.target.value),
                        isClosed: !!workingHours?.isClosed,
                        fieldName,
                    })}
                    disabled={workingHours?.isClosed}
                />
            </div>
            <div className={styles.toggleGroup}>
                <CustomSwitchField
                    textOnTrue={"Opened"}
                    textOnFalse={"Closed"}
                    value={!workingHours?.isClosed}
                    toggleValue={(v) => updateWorkingHours({
                        openTime: workingHours?.openTime,
                        closeTime: workingHours?.closeTime,
                        isClosed: !v,
                        fieldName
                    })}
                />
            </div>
        </div>
        {withBorderLine && <div className={styles.line}/>}
    </div>
}
